import React from 'react';
import { Link } from "react-router-dom";
import * as util from "../other/util.js";
import { GameData } from "../share/game-data.js"
import ResourceProductionFormulas from "../share/formulas/resource-production-formulas.js";
import * as Backend from '../backend.js';

// Shows resource production of a planet
export default class PlanetResourceView extends React.Component {
    render() {
        let planet = this.props.planet;
        const [consumption, production] = ResourceProductionFormulas.getPlanetResourceDelta(planet);
        this.consumption = consumption;
        this.production = production;

        if (!planet) {
            return (<util.LoadingBar thing={planet} thingName="planet" />);
        }

        let solar_plant_link = (<Link className="link-button" to={{ pathname: '/game/building-info/solar' }}>{GameData.buildingName("solar")}s</Link>);
        let storage_link = (<Link className="link-button" to={{ pathname: '/game/building-info/storage' }}>{GameData.buildingName("storage")}</Link>);
        let resource_capacity = ResourceProductionFormulas.getRawStorageCapacity(planet.buildings.storage);

        return (
            <div>
                <h1>Resources</h1>
                <h2>Worker</h2>
                <TaxSectionView planet={planet} />
                <h2>Energy</h2>
                <p className="boring-info-text">Energy is produced in {solar_plant_link}. A shortage will drastically reduce
                    the efficiency of your other facilities.</p>
                {this.renderEnergy()}
                <h2>Resources</h2>
                <p className="boring-info-text">All resources are stored in the planets {storage_link} ({resource_capacity} per resource). Once the depot
                    is full, the production is stopped. Changes are shown per hour.</p>
                {this.renderResources()}
            </div>
        );
    }

    renderEnergy() {
        let planet = this.props.planet;
        let energy = ResourceProductionFormulas.getRawEnergyStats(planet);

        let energy_warning;
        if (energy.efficiency !== 1) {
            energy_warning = (
                <div style={{ color: "red" }}>Warning: Insufficient energy, all production buildings can only work
                    at {Math.round(energy.efficiency * 100)}% efficiency.</div>);
        }

        return (
            <div>
                <table className="resources">
                    <thead>
                        <tr>
                            <td>Production</td>
                            <td>Consumption</td>
                            <td>Access</td>
                            <td>Efficiency</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="summary">
                            <td style={{ textAlign: "right" }}> {energy.production} </td>
                            <td style={{ textAlign: "right" }}> {energy.consumption} </td>
                            <td style={{ textAlign: "right" }}>
                                <util.ResourceProductionDelta delta={energy.production - energy.consumption} />
                            </td>
                            <td style={{ textAlign: "right" }}>
                                <util.ResourceProductionPercentage ratio={energy.efficiency} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                {energy_warning}
            </div>);
    }

    renderResources() {
        let planet = this.props.planet;
        let html = GameData.RESOURCES.map((resource, idx) => {
            let production = this.production[resource.id];
            let consumption = this.consumption[resource.id];
            return (
                <tr key={idx}>
                    <td>{resource.ui_name}</td>
                    <td style={{ textAlign: "right" }}>
                        <util.ResourceProductionDelta delta={-consumption} />
                    </td>
                    <td style={{ textAlign: "right" }}>
                        <util.ResourceProductionDelta delta={production} />
                    </td>
                    <td style={{ textAlign: "right" }}>
                        <util.ResourceProductionDelta delta={production - consumption} />
                    </td>
                    <td style={{ textAlign: "right" }}>
                        <util.ResourceNumber number={planet.resources[resource.id]} />
                    </td>
                </tr>
            );
        });

        return (
            <div>
                <table className="resources">
                    <thead>
                        <tr>
                            <td />
                            <td>Consumption</td>
                            <td>Production</td>
                            <td>Total</td>
                            <td>Stored</td>
                        </tr>
                    </thead>
                    <tbody>
                        {html}
                    </tbody>
                </table>
            </div>
        );
    }
}

class TaxSectionView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { tax_percentage: this.props.planet.tax_percentage };
    }

    handleTaxPercentageChange(tax_percentage) {
        this.setState({ tax_percentage: tax_percentage });

        const planet = this.props.planet;
        if (planet.tax_percentage !== tax_percentage) {
            Backend.trySetTaxPercentage(planet.x, planet.y, planet.z, tax_percentage, res => {
                console.log("Tax percentage updated:", res);
            });
        }
    }

    render() {
        const planet = this.props.planet;
        const worker_count = planet.resources.worker + planet.working_worker_count;
        const worker_production = ResourceProductionFormulas.getPlanetWorkerProduction(planet, this.state.tax_percentage);
        const worker_capacity = ResourceProductionFormulas.getRawHousingCapacity(planet.buildings.housing);
        const housing_link = (<Link className="link-button" to={{ pathname: '/game/building-info/housing' }}>{GameData.buildingName("housing")}es</Link>);
        const tax_income = ResourceProductionFormulas.getRawMoneyProduction(worker_count, this.state.tax_percentage);

        let full_warning;
        if (worker_count === worker_capacity) {
            full_warning = (
                <div style={{ color: "red" }}>Warning: Houses are full, no more space for new workers. Production halted.</div>);
        }

        return (
            <div>
                <p className="boring-info-text">
                    Workers live in {housing_link} and produce money for you via taxes.
                    The tax rate can be adjusted below and affects the worker's happiness.
                    Workers reproduce slowly (and somewhat messy) on their own over time.
                    The more workers and the happier they are, the faster they reproduce, like a virus.
                </p>
                <TaxSlider maxAllowed={1.0} onTaxPercentageChange={val => this.handleTaxPercentageChange(val)} tax_percentage={this.state.tax_percentage} />
                <table className="resources">
                    <thead>
                        <tr>
                            <td>Total Worker</td>
                            <td>Housing Capacity</td>
                            <td>Hourly Growth</td>
                            <td>Tax Income</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="summary">
                            <td style={{ textAlign: "right" }}>
                                <util.ShortNumber number={Math.floor(worker_count)} hideDecimals={true} />
                            </td>
                            <td style={{ textAlign: "right" }}>
                                <util.ShortNumber number={worker_capacity} hideDecimals={true} />
                            </td>
                            <td style={{ textAlign: "right" }}>
                                <util.ResourceProductionDelta delta={worker_production} />
                            </td>
                            <td style={{ textAlign: "right" }}>
                                <util.ResourceProductionDelta delta={tax_income} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                {full_warning}
            </div>);
    }
}

class TaxSlider extends React.Component {
    handleTaxRateChange = (e) => {
        const tax_percentage = parseInt(e.target.value);
        this.props.onTaxPercentageChange(tax_percentage);
    };

    render() {
        const tax_percentage = this.props.tax_percentage;
        const happiness_percentage = 100 - tax_percentage;

        return (
            <div className="tax-slider-container">
                <div className="tax-slider-side">
                    <div className="tax-slider-label">Happiness</div>
                    <div className="tax-slider-value">{happiness_percentage}%</div>
                </div>

                <input
                    type="range"
                    className="tax-slider"
                    value={tax_percentage}
                    onChange={this.handleTaxRateChange}
                    min="0"
                    max="100"
                    step="5"
                />

                <div className="tax-slider-side">
                    <div className="tax-slider-label">Tax Rate</div>
                    <div className="tax-slider-value">{tax_percentage}%</div>
                </div>
            </div>
        );
    }
}
